var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import classNames from "classnames";
import * as userSettingsActions from "../../actions/userSettings";

import styles from "./UserSettings.css";

var SocialSettings = function (_Component) {
  _inherits(SocialSettings, _Component);

  function SocialSettings() {
    _classCallCheck(this, SocialSettings);

    var _this = _possibleConstructorReturn(this, (SocialSettings.__proto__ || Object.getPrototypeOf(SocialSettings)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(SocialSettings, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.userSettingsActions.typingUserSettings(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      this.props.userSettingsActions.submitUserSettings(this.props.userSettings.data.profileInfo);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: classNames(styles.infoWrapper, styles.marginTop20) },
        React.createElement(
          "div",
          { className: styles.blueHeading },
          "SOCIAL MEDIA"
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "LINKEDIN"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "LinkedIn", name: "linkedin", onChange: this.handleChange, type: "text", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.linkedin })
          )
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "FACEBOOK"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "Facebook", name: "facebook", onChange: this.handleChange, type: "text", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.facebook })
          )
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "TWITTER"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "Twitter", name: "twitter", onChange: this.handleChange, type: "text", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.twitter })
          )
        ),
        React.createElement(
          "div",
          { className: styles.textCenter },
          React.createElement(
            "button",
            { onClick: this.handleSubmit, type: "button", className: classNames(styles.marginTop40, styles.blueButton1, styles.mobileBlock, styles.saveSocialButton) },
            "Save changes"
          )
        )
      );
    }
  }]);

  return SocialSettings;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialSettings);


// WEBPACK FOOTER //
// ./src/users/components/UserSettings/SocialSettings.js